import styled from "styled-components";

import { constants, spacing, theme } from "../../layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  container: {
    padding: `${spacing.m}px 0px`,
    borderRadius: constants.radius.button,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    userSelect: "none",
    cursor: "pointer",
  },
  buttonPrimary: {
    backgroundColor: theme.button.background.primary,
  },
  buttonSecondary: {
    backgroundColor: theme.button.background.secondary,
  },
  disabled: {
    backgroundColor: theme.button.background.disabled,
    pointerEvents: "none",
  },
  textPrimary: {
    color: theme.button.text.primary,
  },
  textSecondary: {
    color: theme.button.text.secondary,
  },
  loader: {
    padding: "2px 0px",
  },
};

export const LoaderContainer = styled.div`
  padding: 17px 0px;
`;
